export class Customer {
  No?: string;
  Name?: string;
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/Customer.ts